//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { payOverTime, locale } = wcs.getStoreConfig()

export default {
  name: 'rb-afterpay-content',
  data: function () {
    return {
      afterpayUrl:
        locale === WcsLocales.FR_CA
          ? 'https://www.afterpay.com/fr-CA/terms-of-service'
          : payOverTime?.afterpay?.checkoutTermsConditionUrl,
    }
  },
}
